module.exports = __webpack_public_path__ + "img/antes_despues_48.dc55f921.png";